import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

export const getServiceDetails = async (serviceId) => {
	try {
		let response = await API.get(`${Apis.Services}/${serviceId}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const patchServiceDetails = async (serviceId, payload) => {
	try {
		let response = await API.patch(`${Apis.Services}/${serviceId}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const changeServiceStatus = async (serviceId, payload) => {
	try {
		let response = await API.post(
			`${Apis.Services}/${serviceId}/changestatus`,
			payload
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const changeMultipleServiceStatus = async (payload) => {
	try {
		let response = await API.post(`${Apis.Services}/changestatus`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const resetServiceStatus = async (serviceId, payload) => {
	try {
		let response = await API.post(
			`${Apis.Services}/${serviceId}/reset`,
			payload
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const postServiceNote = async (payload) => {
	try {
		let response = await API.post(`${Apis.ServiceNotes}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getServiceNotes = async (serviceId) => {
	try {
		let response = await API.get(`${Apis.ServiceNotes}?serviceId=${serviceId}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getCompletedService = async (serviceId) => {
	try {
		let response = await API.get(
			`${Apis.Services}/${serviceId}/completedService`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getServiceWebBaseReport = async (serviceId, timezone) => {
	try {
		let response = await API.get(
			`${Apis.Services}/completedService?serviceId=${serviceId}&timezone=${timezone}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const updateServiceNote = async (noteId, note) => {
	try {
		const patchDocument = [
			{
				op: "replace",
				path: "/note",
				value: note
			}
		];
		let response = await API.patch(`${Apis.ServiceNotes}/${noteId}`, patchDocument);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const deleteServiceNotes = async (serviceId) => {
	try {
		let response = await API.delete(`${Apis.ServiceNotes}/${serviceId}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getServicePeopleList = async (serviceId) => {
	try {
		let response = await API.get(`${Apis.Services}/${serviceId}/sessions`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getIncompleteService = async (serviceId) => {
	try {
		let response = await API.get(
			`${Apis.Services}/${serviceId}/incompleteTasks`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
